<template>
  <v-container fluid class="fill-height pa-0 ma-0">
    <v-row align="start" class="ma-0 fill-height p-relative">
      <v-container fluid class="p-absolute fill-height">
        <v-row class="ma-0 fill-height p-relative pr-10">
          <v-col cols="2">
            <v-item-group>
              <v-item>
                <v-spacer />
              </v-item>
            </v-item-group>
          </v-col>
          <v-col
            v-for="(item, i) in listaDatas"
            :key="i"
            class="bordered-col pa-0"
          />
        </v-row>
      </v-container>
      <v-container fluid>
        <v-row class="ma-0 pb-6 pr-10">
          <v-col cols="2">
            <v-item-group>
              <v-item>
                <v-spacer />
              </v-item>
            </v-item-group>
          </v-col>
          <v-col
            v-for="(item, i) in listaDatas"
            :key="i"
            class="pa-0"
          >
            <v-row
              align="center"
              justify="center"
              class="ma-0 pa-4 fill-height"
            >
              <span class="text-datas-extenso text-capitalize">
                {{ item.semanaText }}
              </span>
              <span class="pl-2 text-datas-number">
                {{ item.dayText }}
              </span>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <slot name="data-grid" />
        </v-row>
      </v-container>
    </v-row>
  </v-container>
</template>

<script>
import {mapState} from "vuex"

export default {
  name: "DemandDateGrid",
  computed: {
    ...mapState("programacaoAbate", ["listaDatas"])
  }
}
</script>

<style scoped lang="scss">
.height-auto {
  flex-basis: 100% !important;
  max-height: 100px !important;
}

.bordered-col {
  position: relative;
  
  &::before {
    pointer-events: none;
    display: block;
    position: absolute;
    content: "";
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    border: 1px #bdccca solid !important;
    border-right: 0.5px #bdccca solid !important;
  }
}
</style>